import { render, staticRenderFns } from "./BettingRecordDetailDialog.vue?vue&type=template&id=f7741a9e&scoped=true"
import script from "./BettingRecordDetailDialog.vue?vue&type=script&lang=js"
export * from "./BettingRecordDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./BettingRecordDetailDialog.vue?vue&type=style&index=0&id=f7741a9e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7741a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7741a9e')) {
      api.createRecord('f7741a9e', component.options)
    } else {
      api.reload('f7741a9e', component.options)
    }
    module.hot.accept("./BettingRecordDetailDialog.vue?vue&type=template&id=f7741a9e&scoped=true", function () {
      api.rerender('f7741a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/member/components/BettingRecordDetailDialog.vue"
export default component.exports